const angular = require('angular');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
require('dialog-polyfill');
const olyDialog = require('oly-dialog');

const wowCommonModule = require('../common/common.module');
const olyCommonModule = require('../olycommon/olycommon.module');
const analyticsModule = require('../analytics/analytics.module');

const orderModuleName = 'wowApp.order';

angular.module(orderModuleName, [analyticsModule, olyCommonModule, wowCommonModule, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
require('./confirmation');
require('./deliveryoptions');
require('./ordermanagement');
require('./savedcard');

module.exports = orderModuleName;



// WEBPACK FOOTER //
// ./src/order/order.module.js